





































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { Course, FeatureSwitches, MobileGetter, User } from 'frontend/types';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';
import ProgressBar from 'frontend/views/courses/CoursePage/components/ProgressBar.vue';
import CoverDescriptions from 'frontend/views/courses/CoursePage/components/CoverDescriptions.vue';
import ModalCourseMap from 'frontend/views/courses/CoursePage/components/ModalCourseMap.vue';
import AdminMenu from 'frontend/components/AdminMenu.vue';
import { populateAdminMenu, withUserActions } from 'frontend/utils/admin';
import { resetCourseState } from 'frontend/views/courses/utils';
import LearningPathBadge from 'frontend/views/learningPathV2/LearningPathBadge.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import ScrollableTopBar from 'frontend/components/ScrollableTopBar.vue';

@Component({
  components: {
    AdminMenu,
    CoverDescriptions,
    BriocheBackgroundImage,
    LearningPathBadge,
    ModalCourseMap,
    ProgressBar,
    ScrollableTopBar,
  },
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
    ...mapGetters('globals', ['featureSwitches']),
  },
})
export default class Cover extends Vue {
  @Prop({ type: Object, required: true })
  private course!: Course;
  @Prop({ type: Boolean, required: true })
  private hasPractice!: boolean;
  @Prop({ type: Boolean, required: true })
  private isInProgressView!: boolean;

  private readonly featureSwitches!: FeatureSwitches;
  private readonly user!: User;
  private readonly isMobile!: MobileGetter;
  private learningPath?: RelatedLearningPathInfo;

  private coverBarIsExpanded: boolean = false;

  private get completionPercentage(): number {
    return (this.course.percent_complete || 0) / 100;
  }

  private get lessons(): number {
    return this.course.num_quizzes || 0;
  }

  private get adminMenu() {
    return withUserActions(
      this.user,
      populateAdminMenu(
        this.course,
        'course',
        this.$router,
        this.featureSwitches.use_retool_campgrounds,
      ),
    );
  }

  private toggleExpandedCoverBar(event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    if (this.coverBarIsExpanded) {
      this.coverBarIsExpanded = false;

      window.document.body.style.overflow = '';
      (this.$refs.closableOverlay as Element).removeEventListener(
        'touchstart',
        this.toggleExpandedCoverBar,
      );
    } else {
      this.coverBarIsExpanded = true;

      window.document.body.style.overflow = 'hidden';
      // Wait for the closableOverlay to be mounted before adding the listener.
      this.$nextTick(() =>
        (this.$refs.closableOverlay as Element).addEventListener(
          'touchstart',
          this.toggleExpandedCoverBar,
        ),
      );
    }
  }

  private async handleResetCourseState() {
    await resetCourseState(this.course.slug);
    window.location.reload();
  }

  private async handleBulkResetCourseState() {
    await resetCourseState(this.course.slug, true);
    window.location.reload();
  }
}
